export default __webpack_public_path__ + "static/media/BussCover.25bb456d.jpg";